import { useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import AmalgamGroup from '../assets/images/Amalgam-Group.png'
import Amalgam from '../assets/images/Amalgam-logo.png'
import Constructive from '../assets/images/carousel-photos/Constructive.png'
import BankOfGuam from '../assets/images/carousel-photos/BankOfGuam.png'
import BureauVanDijk from '../assets/images/carousel-photos/BureauVanDijk.png'
import CleanItSupply from '../assets/images/carousel-photos/CleanItSupply.png'
import Everbank from '../assets/images/carousel-photos/Everbank.png'
import JohnTempleton from '../assets/images/carousel-photos/JohnTempleton.png'
import MTBank from '../assets/images/carousel-photos/M&TBank.png'
import Moodys from '../assets/images/carousel-photos/Moodys.png'
import NGrowth from '../assets/images/carousel-photos/NGrowth.png'
import PearlX from '../assets/images/carousel-photos/PearlX.png'
import PFA from '../assets/images/carousel-photos/PFA.png'
import Sofi from '../assets/images/carousel-photos/Sofi.png'
import Zenbank from '../assets/images/carousel-photos/Zenbanx.png'
import BrighthouseFinancial from '../assets/images/carousel-photos/BrightHouseFinancial.svg'
import Conan from '../assets/images/carousel-photos/ConanMedTech.png'
import Confinity from '../assets/images/carousel-photos/Confinity.svg'
import Consulting from '../assets/images/Consulting.png'
import Cube from '../assets/images/Cube.png'
import Entrprenuer from '../assets/images/Entrepreneurial-Hub.png'
import Facebook from '../assets/images/Facebook.png'
import Fitzmier from '../assets/images/Fitzmier.png'
import Mooney from '../assets/images/Mooney.png'
import Mendoza from '../assets/images/Mendoza.png'
import Instagram from '../assets/images/Instagram.png'
import LinkedIn from '../assets/images/LinkedIn.png'
import Rocket from '../assets/images/Rocket.png'
import Solutions from '../assets/images/Solutions.png'
import TechConsulting from '../assets/images/Tech-Consulting.png'
import Header from '../assets/components/Header'
import X from '../assets/images/X.png'
import Youtube from '../assets/images/Youtube.png'
import LeftQoutes from '../assets/images/LeftQuotes.png'
import RightQoutes from '../assets/images/RightQuotes.png'
import Writing from '../assets/images/Writing.png'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/home.css'
import { useMediaQuery } from 'react-responsive';
import FitzmierBanner from '../assets/images/FitzmierBanner.png'
import MooneyBanner from '../assets/images/MooneyBanner.png'
import MendezBanner from '../assets/images/MendezBanner.png'






function Home() {
    const navigate = useNavigate();
    const isMobile = useMediaQuery({ maxWidth: 570 });
    const isTablet = useMediaQuery({ maxWidth: 1100 });
    // const { pathname } = useLocation();
    // useEffect(() => {
    //     // window.scrollTo(0, 0); // Scroll to the top
    // }, [pathname]);
    return (

        <div style={{ boxSizing: "border-box" }}>

            <div className='home-row-1'>
                <div className='home-row-1-text-box'>
                    <h1 className="home-row-1-heading">We're the rocket fuel to your moonshot</h1>
                    <p className='home-text'>We empower visionary business owners like you to make their ideas come to life. Benefit from our long-standing expertise in business development and product-building, and access our network of enlightened entrepreneurs.</p>
                    <p className='home-text'>Are you working on a breakthrough idea?</p>
                    <button className='home-lets-talk' onClick={() => { navigate("./contactus") }}>Let's talk</button>
                    <img src={Rocket} className='rocket2' alt='Rocket' />
                </div>
                <img src={Rocket} className='rocket' alt='Rocket' />
            </div>

            <div className='home-row-2'>
                <h3 className='home-row-2-header'>Trusted by big names and rising stars alike</h3>
                <div className='home-row-2-worked-with'>
                    <div className='home-row-2-carousel-1 home-slide-across'>
                        <img src={Constructive} className='constructive ' alt='constructive' />
                        <img src={BankOfGuam} className='bankofguam ' alt='BankOfGuam' />
                        <img src={Moodys} className='moodys' alt='moodys' />
                        <img src={JohnTempleton} className='johntempleton' alt='johntempleton' />
                        <img src={NGrowth} className='ngrowth' alt='ngrowth' />
                        <img src={PFA} className='pfa' alt='pfa' />
                        <img src={Sofi} className='sofi' alt='sofi' />
                        <img src={Everbank} className='tiaa' alt='everbank' />
                        <img src={CleanItSupply} className='cleanitsupply' alt='CleanItSupply' />
                        <img src={MTBank} className='mtbank' alt='mtbank' />
                        <img src={PearlX} className='pearlx' alt='pearlx' />
                        <img src={Zenbank} className='zenbank' alt='zenbank' />
                        <img src={BrighthouseFinancial} alt="brighthousefinancial" className='brighthousefinancial' />
                        <img src={Conan} alt="conan" className='conan' />
                        <img src={Confinity} alt="confinity" className='confinity' />
                        <img src={Constructive} className='constructive ' alt='constructive' />
                        <img src={BankOfGuam} className='bankofguam ' alt='BankOfGuam' />
                        <img src={Moodys} className='moodys' alt='moodys' />
                        <img src={JohnTempleton} className='johntempleton' alt='johntempleton' />
                        <img src={NGrowth} className='ngrowth' alt='ngrowth' />
                        <img src={PFA} className='pfa' alt='pfa' />
                        <img src={Sofi} className='sofi' alt='sofi' />
                        <img src={Everbank} className='tiaa' alt='tiaa' />
                        <img src={CleanItSupply} className='cleanitsupply' alt='CleanItSupply' />
                        <img src={MTBank} className='mtbank' alt='mtbank' />
                        <img src={PearlX} className='pearlx' alt='pearlx' onClick={() => navigate('/pearlx')} />
                        <img src={Zenbank} className='zenbank' alt='zenbank' />
                        <img src={BrighthouseFinancial} alt="brighthousefinancial" className='brighthousefinancial' />
                        <img src={Conan} alt="conan" className='conan' />
                        <img src={Confinity} alt="confinity" className='confinity' />
                        <img src={Constructive} className='constructive ' alt='constructive' />
                        <img src={BankOfGuam} className='bankofguam ' alt='BankOfGuam' />
                        <img src={Moodys} className='moodys' alt='moodys' />
                        <img src={JohnTempleton} className='johntempleton' alt='johntempleton' />
                        <img src={NGrowth} className='ngrowth' alt='ngrowth' />
                        <img src={PFA} className='pfa' alt='pfa' />
                        <img src={Sofi} className='sofi' alt='sofi' />
                        <img src={Everbank} className='tiaa' alt='tiaa' />
                        <img src={CleanItSupply} className='cleanitsupply' alt='CleanItSupply' />
                        <img src={MTBank} className='mtbank' alt='mtbank' />
                        <img src={PearlX} className='pearlx' alt='pearlx' onClick={() => navigate('/pearlx')} />
                        <img src={Zenbank} className='zenbank' alt='zenbank' />
                        <img src={BrighthouseFinancial} alt="brighthousefinancial" className='brighthousefinancial' />
                        <img src={Conan} alt="conan" className='conan' />
                        <img src={Confinity} alt="confinity" className='confinity' />
                    </div>

                </div>
            </div>

            <div className='home-row-3'>
                <div className='home-row-3-container'>
                    <div className='home-row-3-left'>
                        <h1 className='home-row-3-left-header'>Connecting the dots</h1>
                        <p className='home-row-3-left-text'>The best things in life come in threes. So does our offering.</p>
                    </div>
                    <div className='home-row-3-right'>
                        <img src={Solutions} className='solutions' alt='Placeholder' />
                    </div>
                </div>
            </div>

            <div className='home-row-4'>
                <div className='home-row-4-top'>
                    {/* <h1 className='home-row-4-top-header'>How we can help you</h1> */}
                </div>

                <div className='home-row-4-bottom'>
                    <div className='home-row-4-images'>
                        <img src={Consulting} alt="Consulting" className='consulting' />
                        <div>
                            <p className='home-row-4-image-headers'>Business consulting</p>
                            <p className='home-row-4-image-subheader'>Our experienced team of consultants is ready to guide you through every step of your business journey, from growth advice to rebranding and beyond.</p>
                        </div>
                    </div>
                    <div className='home-row-4-images'>
                        <img src={TechConsulting} alt="Consulting" className=' tech-consulting' />
                        <div>
                            <p className='home-row-4-image-headers'>Bespoke tech solutions</p>
                            <p className='home-row-4-image-subheader'>We empower you with a wide range of bespoke tech solutions with transparent value, from custom software development to generative AI.</p>
                        </div>
                    </div>
                    <div className='home-row-4-images'>
                        <img src={Entrprenuer} alt="Consulting" className=' entrepreneur' />
                        <div>
                            <p className='home-row-4-image-headers'>Entrepreneurial hub</p>
                            <p className='home-row-4-image-subheader'>We're your bridge to top-tier consultants, forward-thinking business owners, funders, and investors.</p>
                        </div>
                    </div>
                </div>
                <button className='lets-talk-button'>
                    <Link to="/contactus" className="navlink">Let's talk</Link>
                </button>


            </div>

            <div className='home-row-5'>
                <div className='home-row-5-headers'>
                    <p className='home-row-5-header'>Amalgam in numbers</p>
                    <p className='home-row-5-sub-header'>We've spent the past decade serving clients around the globe. With 500+ years of accumulated knowledge, you know you're in expert hands. We're looking forward to supporting your business's needs.</p>
                </div>
                <div className='home-row-5-statistics'>
                    <div className='home-row-5-stat'>
                        <div className='home-row-5-stat-header'>10+</div>
                        <div className='home-row-5-stat-sub-header'>Years in business</div>
                    </div>
                    <div className='home-row-5-stat'>
                        <div className='home-row-5-stat-header'>30+</div>
                        <div className='home-row-5-stat-sub-header'>Clients around the globe</div>
                    </div>
                    <div className='home-row-5-stat'>
                        <div className='home-row-5-stat-header'>500+</div>
                        <div className='home-row-5-stat-sub-header'>Years of accumulated experience</div>
                    </div>
                </div>
            </div>

            <div className='home-row-6' >
                <div>

                    <div className='home-row-6-header' id='home-row-6-header'>
                        Why us? Hear it from <br className='home-row-6-header-br' /> our clients
                    </div>
                    <div>
                        <img src={FitzmierBanner} className='fitzmier' />
                    </div>
                    <div>
                        <img src={MooneyBanner} className='mooney' />
                    </div>
                    <div>

                        <img src={MendezBanner} className='fitzmier' />
                    </div>
                </div>
            </div>


            <div className='home-row-7' >
                <div className='home-row-7-container'>
                    <div>
                        <p className='home-row-7-header'>We meet you where<br className='home-row-7-header-br' /> you are</p>
                        <p className='home-row-7-text'>From your business's conceptual phase to the realization of your most ambitious plans, our end-to-end solution gets you where you want to be. At what stage of your journey are you?</p>
                        <button style={{whiteSpace: "nowrap"}} onClick={() => navigate('/contactus')}>Let's Connect</button>
                    </div>
                </div>
                <img src={AmalgamGroup} className='amalgam-group' alt='Amalgam-group' />
            </div>
            <div className='divider'>
            </div>
            <div className='home-row-8' >
                <div className='home-row-8-header business-consulting'>Business consulting</div>
                <div className='home-row-8-content' >
                    <div>
                        <h3>Business & strategy consulting</h3>
                        <p>We'll be your strategic partners and help you manage your risk and performance</p>
                    </div>
                    <div>
                        <h3>Operational optimization</h3>
                        <p>We'll help you manage changes, reengineer your business processes, and transform your operations so they're as effective as can be</p>
                    </div>
                    <div>
                        <h3>Marketing & branding support</h3>
                        <p>We'll support you with your branding and market positioning, optimizing the way you present yourself to your potential customers</p>
                    </div>
                </div>
                <div className='home-row-8-header'>Bespoke tech solutions</div>
                <div className='home-row-8-content2'>
                    <div>
                        <h3>Customer experience & UX/UI</h3>
                        <p>We'll refine your user experience and craft intuitive, visually appealing interfaces to enhance every interaction your customers have with your brand.</p>
                    </div>
                    <div>
                        <h3>Web & mobile app development</h3>
                        <p>We're excited to deliver solutions that are both functional and innovative, whether it's by building a sleek website or a robust mobile application.</p>
                    </div>
                    <div>
                        <h3>Artificial Intelligence & machine learning</h3>
                        <p>We'll help you unlock new insights and make your operations more efficient than ever by harnessing the power of AI and ML.</p>
                    </div>
                    <div id='home-row-8-content2-mobile'>
                        <h3>Databases, integrations & tools</h3>
                        <p>JAVA, GO and Scala Technologies | JavaScript frameworks (i.e. angular, react, node, rekit, view) | .NET framework and Akka framework | Content Management Systems with specialization in Magnolia and Wordpress</p>
                    </div>
                    <div id='home-row-8-content2-mobile'>
                        <h3>Cloud & management Services</h3>
                        <p>PostgreSQL, MongoDB, NoSQL, SnowFlake, SQL Server, Elastic Search, Pentaho BI, Okta, Firebase, Signrequest , Big Data and BI tools using Python, R, PowerBI, Tableau.</p>
                    </div>
                    <div id='home-row-8-content2-mobile'>
                        <h3>Web3 & Blockchain</h3>
                        <p>Corda R3, Hyperledger, Ethereum | AWS, Digital Ocean, GCP, Azure | Docker, Kubernetes | FIS Profile Banking Core and Channels, Bottomline Digital Banking</p>
                    </div>
                </div>
                <div className='home-row-8-content3'>
                    <div>
                        <h3>Databases, integrations & tools</h3>
                        <p>JAVA, GO and Scala Technologies | JavaScript frameworks (i.e. angular, react, node, rekit, view) | .NET framework and Akka framework | Content Management Systems with specialization in Magnolia and Wordpress</p>
                    </div>
                    <div>
                        <h3>Cloud & management Services</h3>
                        <p>PostgreSQL, MongoDB, NoSQL, SnowFlake, SQL Server, Elastic Search, Pentaho BI, Okta, Firebase, Signrequest , Big Data and BI tools using Python, R, PowerBI, Tableau.</p>
                    </div>
                    <div>
                        <h3>Web3 & Blockchain</h3>
                        <p>Corda R3, Hyperledger, Ethereum | AWS, Digital Ocean, GCP, Azure | Docker, Kubernetes | FIS Profile Banking Core and Channels, Bottomline Digital Banking</p>
                    </div>
                </div>

                <div className='home-row-8-header'>Entrepreneurial hub</div>
                <div className='home-row-8-content4' >
                    <div>
                        <h3>Tech & advisory</h3>
                        <p>Our top consultants and tech advisors are ready to share the invaluable insights and guidance you need to make your moonshot a reality.</p>
                    </div>
                    <div>
                        <h3>Funding</h3>
                        <p>Plenty of investors in our community—who knows? Your business idea may be just the funding opportunity they're looking for.</p>
                    </div>
                    <div>
                        <h3>Networking</h3>
                        <p>Grow your network and influence by engaging with forward-thinking business owners, industry leaders, and key partners. We're ready to introduce you to our trusted partners and peers.</p>
                    </div>
                </div>

            </div>


            <div className='home-row-12'>
                <div className='home-row-12-content'>
                    <div>
                        <p className='home-row-12-header'>
                            Get in touch
                        </p>
                        <p className='home-row-12-text'>Reach out to us to gather more information or set our wheels in motion.</p>
                        <button className='home-lets-talk-bottom' onClick={() => navigate("/contactus")}>Let's talk</button>
                    </div>
                </div>
                <img src={Writing} alt="Writing" id='writing' />
            </div>

            {!isTablet ? (
                <section className='home-footer'>
                    <div className='home-footer-middle'>
                        <img src={Amalgam} alt="Amalgam" className='home-footer-amalgam' />
                        <Link to="/" className='home-footer-links'>Home</Link>
                        <Link to="/ourwork" className='home-footer-links'>Our Work</Link>
                        <Link to="/aboutus" className='home-footer-links'>About Us</Link>
                        <Link to="/case-studies" className='home-footer-links'>Case Studies</Link>
                        <Link to="/startups" className='home-footer-links'>Launchpad</Link>
                        <Link to="/careers" className='home-footer-links'>Careers</Link>
                        <Link to="/contactus" className='home-footer-links'>Contact Us</Link>
                        <img src={LinkedIn} alt="Instagram" className='home-footer-linkedin' />
                    </div>
                    <div className='home-footer-dividor'>
                        <div className='home-footer-policies'>
                            <p><Link to="/privacy-policy">Privacy Policy</Link></p>
                            <p><Link to="/terms-and-conditions">Terms and Conditions</Link></p>
                            <p><Link to="/cookie-policy">Cookie Policy</Link></p>
                        </div>
                    </div>
                </section>
            ) : (
                <section>
                    <div className="footer-minimal" style={{width: "100%", border: ""}}>
                        <div className="footer-content" style={{display: "flex", alignItems: "center", justifyContent: "center", border: ""}}>
                            <div style={{ display: 'none', flexDirection: 'row', alignItems: 'flex-start',alignSelf: "flex-start",paddingLeft: "90px", gap: '20px' }}>
                                <img src={Amalgam} alt="Amalgam" className="footer-logo" />
                                <img src={LinkedIn} alt="Instagram" className='home-footer-linkedin' style={{ alignSelf: "center" }} />
                            </div>
                            <div className="footer-top-row">

                                <Link to="/" className="footer-link">Home</Link>
                                <span className="footer-separator">•</span>
                                <Link to="/ourwork" className="footer-link">Our Work</Link>
                                <span className="footer-separator">•</span>
                                <Link to="/aboutus" className="footer-link">About Us</Link>
                                <span className="footer-separator">•</span>
                                <Link to="/case-studies" className="footer-link">Case Studies</Link>
                            </div>
                            <div className="footer-bottom-row">
                                <Link to="/startups" className="footer-link">Launchpad</Link>
                                <span className="footer-separator">•</span>
                                <Link to="/careers" className="footer-link">Careers</Link>
                                <span className="footer-separator">•</span>
                                <Link to="/contactus" className="footer-link">Contact</Link>
                            </div>
                        </div>
                    </div>

                    <div style={{
                        width: "80%",
                        height: "0px",
                        borderTop: "1px solid black",
                        backgroundColor: "white",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        paddingBottom: "20px",
                        margin: "0 auto"
                    }}>
                    </div>
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "white",
                        gap: isMobile ? "5px" : "20px",
                        paddingBottom: "20px",
                        width: "100%",
                        padding: "0 10px 20px 10px",
                        textAlign: "center"
                    }}>
                        <Link to="/privacy-policy" style={{ textAlign: "center", color: "black", textDecoration: "none" }}>Privacy Policy</Link>
                        <span style={{ color: "black", fontSize: "14px" }}>|</span>
                        <Link to="/terms-and-conditions" style={{ color: "black", textDecoration: "none" }}>Terms and Conditions</Link>
                        <span style={{ color: "black", fontSize: "14px" }}>|</span>
                        <Link to="/cookie-policy" style={{ fontSize: "14px", color: "black", textDecoration: "none" }}>Cookie Policy</Link>
                    </div>
                </section>
            )}


        </div >
    )
}
export default Home